const initialState = { 
    reportsSuccess: 0,
    percentage: 0,
    reportsError: 0,
    sizePerPage: 10,
    activePage: 1,

    reportErrorList: []
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {

    case "MAP_REPORTS_ACTIVE_PAGE":
        return{
            ...state,
            activePage: action.data       
        }

    case "MAP_REPORTS_SIZE_PER_PAGE":
        return{
            ...state,
            sizePerPage: action.data       
        }

    case "MAP_REPORTS_SUCCESS":
        return{
            ...state,
            reportsSuccess: action.data       
        }

    case "MAP_REPORTS_ERROR":
        return{
            ...state,
            reportsError: action.data       
        }

    case "MAP_REPORTS_UPLOAD_PERCENTAGE":
        return{
            ...state,
            percentage: action.data       
        }

    case "MAP_REPORTS_ERROR_LIST":
        return{
            ...state,
            reportErrorList: [
                ...state.reportErrorList, action.data
            ]
        }

    case "MAP_REPORTS_ERROR_LIST_RESET":
        return{
            ...state,
            reportErrorList: []
        }

    case "MAP_REPORTS_ERROR_LIST_CHANGE":
        return {
            ...state,
            reportErrorList: state.reportErrorList.map(                
                (content, i) => i === action.data.index ? {...content, [action.data.variable]: action.data.value}
                                        : content
            )
        }

    case "MAP_REPORTS_ERROR_LIST_SUCCESS":
        return {
            ...state,
            reportErrorList: state.reportErrorList.filter(data => data["INDETIFIKATOR NARUDŽBE"] !== action.data)
        }
   
    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
